export default __webpack_public_path__ + "static/media/moh-linda.aed82a3d.png";